import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksStaffPayments(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		options
	)
}

function _getOrderGeneratorsFieldsWorksStaffPayment(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
		options
	)
}

function _createOrderGeneratorsFieldsWorksStaffPayment(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
		options
	)
}

function _putOrderGeneratorsFieldsWorksStaffPayment(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksStaffPayment(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksStaffPayment(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS]: _getOrderGeneratorsFieldsWorksStaffPayments,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: _getOrderGeneratorsFieldsWorksStaffPayment,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: _createOrderGeneratorsFieldsWorksStaffPayment,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: _putOrderGeneratorsFieldsWorksStaffPayment,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: _patchOrderGeneratorsFieldsWorksStaffPayment,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: _deleteOrderGeneratorsFieldsWorksStaffPayment,
}